import { forwardRef, HTMLAttributes, PropsWithChildren } from 'react';

import { mapStyledProps, SizeProps } from '../../styles';
import { DefaultComponentProps } from '../../types';

import { ListRoot } from './styled';

export type ListProps = HTMLAttributes<HTMLUListElement> &
  DefaultComponentProps &
  SizeProps;

const List = forwardRef<HTMLUListElement, PropsWithChildren<ListProps>>(
  (props, ref) => {
    const { children, width = '100%', ...rest } = props;

    return (
      <ListRoot
        ref={ref}
        role="listbox"
        {...mapStyledProps(rest)}
        $width={width}>
        {children}
      </ListRoot>
    );
  },
);

List.displayName = 'List';

export default List;
